
window.initMobileMenu = function(){
    var burger = document.getElementById('mobi-burger');
    var burger2 = document.getElementById('mobile-nav-burger');
    var mobileClose = document.getElementById('mobile-nav-close');
    var header = document.getElementById('header');

    var timeOut = null;

    var handleToogle = function(event){
        header.style.width = header.offsetWidth + 'px';
        clearTimeout(timeOut);
        timeOut = setTimeout(function(){
            header.style.width = '';
        }, 1000) ;

        document.documentElement.classList.toggle("drawer-open");
        burger.firstElementChild.classList.toggle('material-burger-transformed');
        burger2.firstElementChild.classList.toggle('material-burger-transformed');
        event.preventDefault();


    };
    burger.addEventListener('click', handleToogle);
    burger2.addEventListener('click', handleToogle);
    mobileClose.addEventListener('click', handleToogle);



    function initMobileUserMenu(){
        var links = $('#mobi-user-menu-a') ;
        links.click(function(e){
            var link = $(this);
            var box = $(link.data('target'));

            if(! box.is(':visible')){
                toggle(links.filter('.hover'));
                $('body').one('click', function(){
                    toggle(links.filter('.hover'));
                });
            }
            toggle(link);
            e.stopPropagation();
            return false;
        });
        var toggle = function(link){
            var box = $(link.data('target'));
            box.toggle();
            link.find('.box-arrow').toggle();
            link.toggleClass('hover');
        }
    }
    initMobileUserMenu();


    // login button
    $('#mobi-show-login-a').click(function(){
        showLoginPopup();
        return false;
    });

    // share button
    $('#mobi-menu-share').click(function(){
        openShare($(this).attr('href'));
        return false;
    });

    // powiadomienia
    var mobileNav = $('.mobile-nav');
    var con = mobileNav.find('.loaded-content');
    mobileNav.find('.activable a').click(function(){
        var a = $(this);
        var li = a.parent();
        if(li.hasClass('is-active')){
            con.removeClass('is-active');
            li.removeClass('is-active');
        } else {
            li.addClass('is-active');
            con.addClass('is-active');
            con.html('');
            $.get(a.data('href'), function(data) {
                con.html(data);
            })
        }
        return false;
    })

    //search
    $('#mobi-show-search-a').click(function(){
        var search = mobileNav.find('.search-li').show();
        search.find('input').focus();
        mobileNav.find('.user-li').hide();
        con.addClass('is-active');
        con.html('');
        return false;
    })
    mobileNav.find('.search-li .mdi-magnify').click(function(){
        mobileNav.find('.search-li').hide();
        mobileNav.find('.user-li').show();
        con.removeClass('is-active');
    });




};



// WEBPACK FOOTER //
// ./Resources/assets/js/mobi-menu.js